import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input()
  width: string;
}
